import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => {
  return {
    container: { 
      flex: 1,
      padding: 20
    },
    title: {
      marginBottom: 10,
      font: theme.custom.font.montserrat16Bold,
    },
    subtitle: {
      marginBottom: 10,
      font: theme.custom.font.montserrat14,
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    okBtn: {
      font: theme.custom.font.montserrat14,
      backgroundColor: "#000",
      borderRadius: 20,
      color: "#FFF"
    },
    cancelBtn: {
      font: theme.custom.font.montserrat14,
      marginRight: 20
    }
  };
});

export default useStyles;
